import React, { useMemo, useState } from 'react';
import { useQuery } from "@tanstack/react-query";
import Loading from '../Loading';
import { useNavigate } from 'react-router-dom';
import { getContentViews } from '../../services/data';
import { ColumnFilter } from '../Filters';
import TrendingContentTable from '../Table/TrendingContentTable';

export default function TrendingContentDashboard() {
  const navigate = useNavigate();

  const [duration, setDuration] = useState(30)

  const handleDurationChange = (interval) => {
    setDuration(interval)
  }

  const {
    data: additionalData,
    status: additionalDataStatus,
    isLoading: additionalDataLoading,
    error: additionalDataError,
  } = useQuery({
    queryKey: ['fetchContentViewsTable', duration],
    queryFn: () => getContentViews(duration),
  });


  const columns = useMemo(
    () => [
      {
        Header: 'Video Slug',
        accessor: 'video_slug',
        Filter: ColumnFilter
      },
      {
        Header: 'Trailer',
        accessor: 'trailer',
        Cell: ({ value }) => (value ? 'Yes' : 'No'),
        Filter: ColumnFilter
      },
      {
        Header: 'Type',
        accessor: 'type',
        Filter: ColumnFilter
      },
      {
        Header: 'Views',
        accessor: 'views',
        Filter: ColumnFilter
      },
    ],
    []
  );

  if (additionalDataLoading) return <Loading />
  if (additionalDataError) {
    navigate('/login')
  }

  return (
    <div>
      {additionalDataError && (<h1>Failed to fetch user table</h1>)}
      {(!additionalDataLoading && additionalDataStatus === 'success') && <TrendingContentTable tableData={additionalData?.data.data} columns={columns} onParentIntervalChange={handleDurationChange} parentDuration={duration} />}
    </div>

  )
}
